import * as Yup from 'yup';
import React, { useState, useRef, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { useFormik, Form, FormikProvider } from 'formik';
import { Icon } from '@iconify/react';
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import {
  Link,
  Stack,
  Checkbox,
  TextField,
  IconButton,
  InputAdornment,
  FormControlLabel,
  Typography,
  Avatar,
  Chip,
  Card,
  Input,
  Button
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/system';
import { makeStyles, styled } from '@mui/styles';
import DriveIcon from '@mui/icons-material/DriveEta';
import FileBase64 from 'react-file-base64';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { useTranslation } from 'react-i18next';
import { ToastContainer, toast } from 'material-react-toastify';
import 'material-react-toastify/dist/ReactToastify.css';

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    position: 'relative',
    height: '100px'
  },
  header: {
    display: 'flex',
    position: 'absolute',
    width: 'calc(100%)',
    top: '-70px',
    alignItems: 'flex-end',
    '& > *': {
      margin: '24px 8px'
    }
  },
  spacer: {
    flexGrow: '1'
  },
  avatar: {
    border: `3px solid white`,
    width: 80,
    height: 80
  },
  actionGroup: {
    display: 'flex',
    width: '330px',
    justifyContent: 'space-between',
    marginRight: 0
  },
  summaryCards: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  summaryCard: {
    margin: 8,
    flexGrow: 1,
    padding: 24
  },
  tripCard: {
    margin: 8,
    padding: 16
  },
  input: {
    display: 'none'
  },
  large: {
    width: 100,
    height: 100
  }
}));

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#f78181'
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#f78181'
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'lightgray'
    },
    '&:hover fieldset': {
      borderColor: '#f78181'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#f78181'
    }
  }
});

export default function ProfileForm() {
  const classes = useStyles();
  const [baseImage, setBaseImage] = useState('');
  const [t, i18n] = useTranslation();

  function convertBase64(photo) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(photo);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  }
  const uploadImage = async (e) => {
    const file = e.target.files[0];
    const base64 = await convertBase64(file);
    setBaseImage(base64);
  };
  const hiddenFileInput = React.useRef(null);
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };

  const notifySuccess = () => {
    toast.success('Your profile has been updated', {
      position: 'bottom-right',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
  };
  const notifyErrorProfile = (messageError) => {
    toast.error(messageError, {
      position: 'bottom-right',
      autoClose: 3000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true
    });
  };

  const ProfileSchema = Yup.object().shape({
    email: Yup.string().email('Email must be a valid email address').required('Email is required'),
    username: Yup.string().required('Full name is required'),
    phone: Yup.string().required('Phone is required')
  });

  const userDetails = JSON.parse(localStorage.getItem('user'));
  const [userName, setUserName] = useState(userDetails.username);
  const API_ENDPOINT = process.env.REACT_APP_BASE_URL;
  const formik = useFormik({
    initialValues: {
      username: userDetails.username,
      email: userDetails.email,
      phone: userDetails.phone,
      photo: `${API_ENDPOINT}${userDetails.photo}`
    },
    validationSchema: ProfileSchema,
    onSubmit: (values) => {
      const pic = `${API_ENDPOINT}${userDetails.photo}`;
      console.log('piiiiiiiic', values.photo);
      const formData = new FormData();
      formData.append('username', values.username);
      formData.append('email', values.email);
      formData.append('phone', values.phone);
      if (pic !== values.photo) {
        formData.append('photo', values.photo);
      }
      const token = localStorage.getItem('access');
      console.log('data', values);
      axios({
        method: 'put',
        url: `${API_ENDPOINT}/api/update-profile/`,
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
        data: formData
      })
        .then((res) => {
          localStorage.setItem('user', JSON.stringify(res.data.data));
          setUserName(res.data.data.username);
          notifySuccess();
          console.log('response.data', res.data.data);
        })
        .catch((err) => {
          console.log('err', err);
          notifyErrorProfile(err.message);
        });
    }
  });
  const { errors, touched, isSubmitting, getFieldProps, setFieldValue, values } = formik;
  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={formik.handleSubmit}>
        <ToastContainer />
        <div
          style={{
            height: '300px',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            filter: 'contrast(75%)',
            backgroundImage: 'url(/static/slider/parent.jpg)'
          }}
        />
        <div className={classes.headerContainer}>
          <div className={classes.header}>
            <IconButton
              onClick={handleClick}
              color="primary"
              aria-label="upload picture"
              component="span"
            >
              <Avatar
                alt="ikram"
                classes={{ root: classes.large }}
                src={baseImage || values.photo}
              />
            </IconButton>
            <input
              type="file"
              style={{ display: 'none' }}
              multiple={false}
              ref={hiddenFileInput}
              onChange={(e) => {
                uploadImage(e);
                setFieldValue('photo', e.currentTarget.files[0]);
              }}
            />
            <Typography style={{ padding: '0px 30px', textTransform: 'capitalize' }} variant="h5">
              {userName}
            </Typography>
            <Chip style={{ backgroundColor: '#ec8181', color: 'white' }} label="Admin" />
          </div>
        </div>
        <Stack style={{ padding: '30px' }} spacing={3}>
          <CssTextField
            fullWidth
            required
            autoComplete="fullname"
            type="text"
            label={t('NometPrénom')}
            {...getFieldProps('username')}
            error={Boolean(touched.username && errors.username)}
            helperText={touched.username && errors.username}
          />
          <CssTextField
            fullWidth
            required
            autoComplete="username"
            type="email"
            label={t('email')}
            {...getFieldProps('email')}
            error={Boolean(touched.email && errors.email)}
            helperText={touched.email && errors.email}
          />
          <CssTextField
            fullWidth
            required
            label={t('phone')}
            type="text"
            {...getFieldProps('phone')}
            error={Boolean(touched.phone && errors.phone)}
            helperText={touched.phone && errors.phone}
          />
          <Box textAlign="right" justifyContent="space-between">
            <Button
              style={{ maxWidth: '100px', backgroundColor: '#f78181' }}
              type="submit"
              variant="contained"
              loading={isSubmitting}
            >
              {t('modifier')}
            </Button>
          </Box>
        </Stack>
      </Form>
    </FormikProvider>
  );
}
